import { render } from "./CustomerIntegrationsList.vue?vue&type=template&id=f7b1a124&scoped=true"
import script from "./CustomerIntegrationsList.vue?vue&type=script&lang=js"
export * from "./CustomerIntegrationsList.vue?vue&type=script&lang=js"

import "./CustomerIntegrationsList.vue?vue&type=style&index=0&id=f7b1a124&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b1a124"]])

export default __exports__